module.exports = __webpack_public_path__ + "static/media/updateContactSmall.802a3136.svg";